import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { RespiratoryQuestionnaireItem } from './questionnaire'

export const RESPIRATORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [RespiratoryQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_RESPIRATORY_WNL]:
    QuestionnaireAnswerType.STRING,
  [RespiratoryQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_COUGH]:
    QuestionnaireAnswerType.STRING,
  [RespiratoryQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_OXYGEN]:
    QuestionnaireAnswerType.STRING,
  [RespiratoryQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_LUNG_SOUNDS]:
    QuestionnaireAnswerType.STRING,
  [RespiratoryQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
